module.exports = __webpack_public_path__ + "static/media/leftmenu.67b51760.png";